module.exports = __webpack_public_path__ + "static/bookimage-0bfbdccccdd1c63cf401308a6c3753d2.jpg";